
const VocabRquestAllowance = {
      scan_me: [
    "Escanea para permitir que\n{variable}\nacceda a tu perfil",
    "Scan to grant\n{variable}\naccess to your profile"
  ]
  }
  export default VocabRquestAllowance;
    